import request from '@/utils/request';

// 获取组织/公司列表
export var getOrganizeList = function getOrganizeList(data) {
  return request({
    url: '/api/permission/Organize',
    method: 'GET',
    data: data
  });
};

// 获取组织/公司下拉框列表
export var getOrganizeSelector = function getOrganizeSelector(id) {
  return request({
    url: '/api/permission/Organize/Selector/' + (!!id ? id : 0),
    method: 'GET'
  });
};

// 获取组织/公司树形
export var getOrganizeTree = function getOrganizeTree() {
  return request({
    url: '/api/permission/Organize/Tree',
    method: 'GET'
  });
};

// 新建组织/公司
export var createOrganize = function createOrganize(data) {
  return request({
    url: '/api/permission/Organize',
    method: 'POST',
    data: data
  });
};

// 修改组织/公司
export var updateOrganize = function updateOrganize(data) {
  return request({
    url: "/api/permission/Organize/".concat(data.id),
    method: 'PUT',
    data: data
  });
};

// 获取组织/公司信息
export var getOrganizeInfo = function getOrganizeInfo(id) {
  return request({
    url: "/api/permission/Organize/".concat(id),
    method: 'GET'
  });
};

// 删除组织/公司
export var delOrganize = function delOrganize(id) {
  return request({
    url: "/api/permission/Organize/".concat(id),
    method: 'DELETE'
  });
};

// 更新组织/公司状态
export var updateOrganizeState = function updateOrganizeState(id) {
  return request({
    url: "/api/permission/Organize/".concat(id, "/Actions/State"),
    method: 'PUT'
  });
};
// 获取分级管理
export var getOrganizeTrator = function getOrganizeTrator(organizeId) {
  return request({
    url: "/api/permission/organizeAdminIsTrator/".concat(organizeId),
    method: 'get'
  });
};
// 更新分级管理
export var setOrganizeTrator = function setOrganizeTrator(data) {
  return request({
    url: "/api/permission/organizeAdminIsTrator/".concat(data.organizeId),
    method: 'PUT',
    data: data
  });
};